import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './Page_DeployIntegration.scss';
import { QuaiAdvisorPageLoader } from '@app/advisor-frontend';
import { ModuleFE_AdvisorWindowMessenger } from '@app/advisor-frontend';
export class Page_DeployIntegration extends ComponentSync {
    componentDidMount() {
        ModuleFE_AdvisorWindowMessenger.initializeReceiver();
    }
    render() {
        return _jsx(QuaiAdvisorPageLoader, { text: 'Deploy Integration' });
    }
}
//# sourceMappingURL=Page_DeployIntegration.js.map